import React, { useEffect, useState } from "react";
import { APP_URL, CAP_IG_AUTH_REDIRECT_ROUTE, IG_AUTH_REDIRECT_ROUTE, IG_HELPDESK_URL, NEW_IG_AUTH_METHOD, WEB_APP_URL } from "../../constants/constants";
import MobileView from "../../layouts/MobileView/MobileView";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getIGAuthURL } from "../../services/api/influencer";
import ifAuthenticated from "../../utils/hoc/ifAuthenticated";
import { AppDispatch, getIntendedPath, RootState } from "../../redux-stores/store";
import { useDispatch } from "react-redux";
import { getErrorMessage, getUserMobileOS, isInstagramBrowser } from "../../utils/helpers";
import { decryptData } from "../../utils/cryptography";
import { debug } from "../../services/api/auth";
import AuthLayout from "../../layouts/AuthLayout";
import ConnectIGComponent from "../../components/igConnect/ConnectIGComponent";
import { ConnectIGStatus } from "./ConnectIGRedir";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Browser } from '@capacitor/browser';
import { isNativePlatform } from "../../utils/platformUtil";


const REDIRECT_URI = (isNativePlatform() ? WEB_APP_URL : APP_URL) + (isNativePlatform() ? CAP_IG_AUTH_REDIRECT_ROUTE : IG_AUTH_REDIRECT_ROUTE);

const helpTopics = [
    {
        title: "OAuthException: Your account's future activity history of Meta technologies is currently turned off.",
        href: `${IG_HELPDESK_URL}/oauth-exception-your-activity-off-meta-technologies`,
    },
    {
        title: "Password is not correct",
        href: `${IG_HELPDESK_URL}/password-not-correct`,
    }
]


const ConnectIG: React.FC = () => {
    const [connected, setConnected] = useState<boolean>(false);
    const [status, setStatus] = useState<ConnectIGStatus>(ConnectIGStatus.DEFAULT);
    const [searchParams] = useSearchParams();

    const verification = useSelector((state: RootState) => state.influencer.influencer?.verification);

    const [error, setError] = useState<any>(null);

    const [igAuthURL, setIGAuthURL] = useState<string | null>(null);

    const dispatch: AppDispatch = useDispatch();

    const navigate = useNavigate();

    const connect = async () => {
        if (connected || status !== ConnectIGStatus.URL_FETCHED || !igAuthURL) return;
        setStatus(ConnectIGStatus.REDIRECTING);

        // Redirect user to Instagram for authentication
        if (NEW_IG_AUTH_METHOD) {
            if (isNativePlatform()) {
                await Browser.open({
                    url: igAuthURL,
                })
                // await InAppBrowser.openInSystemBrowser({
                //     url: igAuthURL,
                //     options: DefaultSystemBrowserOptions,
                // });
                // // Listen for navigation to your redirect URI
                // await InAppBrowser.addListener("browserPageNavigationCompleted", async (data) => {
                //     console.log("Navigation to:", data.url);
                //     if (data?.url?.startsWith(REDIRECT_URI)) {
                //         console.log('redirected to redirect_uri', data.url);
                //         // Extract the code parameter from the redirected URL
                //         const urlObj = new URL(data.url);
                //         const code = urlObj.searchParams.get('code');
                //         await InAppBrowser.close();
                //         if (code) {
                //             // Navigate to the redirect URI with the code as a query parameter
                //             navigate(`${IG_AUTH_REDIRECT_ROUTE}?code=${encodeURIComponent(code)}`);
                //         } else {
                //             // If code is not found, just navigate to the redirect URI
                //             navigate(IG_AUTH_REDIRECT_ROUTE);
                //         }
                //     }
                // });
                return;
            }
            const userOS = getUserMobileOS();
            if (userOS === 'iOS') {
                window.open(igAuthURL, '_blank');
            } else {
                const w = window.open('', '_blank');
                if (w) {
                    w.document.location.assign(igAuthURL);
                }
            }

        } else {
            window.location.href = igAuthURL;
        }
    };

    // Redirect to mobile browser if user is in an in-app browser
    useEffect(() => {
        if (typeof window === "undefined") return;

        const userOS = getUserMobileOS();
        const url = new URL(window.location.href);

        const hasRedirected = url.searchParams.get("redirected");

        if (isInstagramBrowser() && userOS && !hasRedirected) {
            const timer = setTimeout(() => {
                url.searchParams.set("redirected", "true");

                const finalUrl = url.toString();

                if (userOS === "Android") {
                    window.location.href = `intent:${finalUrl}#Intent;end;`;
                } else if (userOS === "iOS") {
                    window.location.href = `x-safari-${finalUrl}`;
                }
            }, 1);

            return () => clearTimeout(timer);
        }
    }, []);


    const handleSkipClick = () => {
        navigate(getIntendedPath())
    }

    useEffect(() => {

        const requestIGAuthURL = async (feature: string | null) => {
            // This function runs when user clicks on Authorize IG Connection CTA aur lands directly after login, when ig connection is required

            try {
                const force = searchParams.get('force');
                const social_account_id = searchParams.get('social_account_id');
                const authURL = await getIGAuthURL(feature, REDIRECT_URI, force, social_account_id);
                if (authURL) {
                    setIGAuthURL(authURL);
                    setStatus(ConnectIGStatus.URL_FETCHED);
                } else {
                    // No auth url recd. means auth is not required, so redirecting back to intended path
                    setConnected(true);
                    window.location.href = getIntendedPath();
                }
            } catch (error) {
                setStatus(ConnectIGStatus.ERROR);
                setError(getErrorMessage(error));
                setConnected(false);
            }

        }

        const urlParams = new URLSearchParams(window.location.search);
        const feature = urlParams.get('feature');
        requestIGAuthURL(feature);

    }, [navigate, dispatch]);

    useEffect(() => {
        localStorage.removeItem('ig_connection_status')
    }, [])

    useEffect(() => {

        const handleBackOnPage = () => {
            if (NEW_IG_AUTH_METHOD) {
                let connectionStatus: any = localStorage.getItem('ig_connection_status');
                connectionStatus = connectionStatus ? decryptData(connectionStatus) : null;

                if (connectionStatus) {
                    setStatus(connectionStatus.status);
                    setError(connectionStatus.error);
                    localStorage.removeItem('ig_connection_status')
                    if (connectionStatus.status === ConnectIGStatus.CONNECTED) {
                        window.location.href = getIntendedPath();
                    }
                    return;
                }
            }

            if (status === ConnectIGStatus.REDIRECTING) {
                setError("Instagram authorization was not completed. Please try again.");
                setStatus(ConnectIGStatus.ERROR);
            }

        }

        const pageShowHandler = async (event: any) => {
            await debug({ path: window.location.pathname, event_name: 'pageshow', event: event, origin: window.location.origin, connection_status: status });
            if (event.persisted) handleBackOnPage();
        }

        const visibilityChangeHandler = async (event: any) => {
            await debug({ path: window.location.pathname, event_name: 'visibilitychange', visibility: document.visibilityState, conditionMatched: (document.visibilityState === 'visible' && status === ConnectIGStatus.REDIRECTING), event: event, origin: window.location.origin, connection_status: status });
            if (document.visibilityState === 'visible') handleBackOnPage();
        }

        window.addEventListener("pageshow", pageShowHandler);
        window.addEventListener("visibilitychange", visibilityChangeHandler);

        return () => {
            window.removeEventListener("pageshow", pageShowHandler);
            window.removeEventListener("visibilitychange", visibilityChangeHandler);
        }

    }, [status])

    useEffect(() => {
        // debug()
        debug({ status, error, path: window.location.pathname, origin: window.location.origin });
    }, [error, status]);



    return (
        <MobileView>
            <AuthLayout
                action={
                    verification?.is_verified ? (
                        <a href="https://api.whatsapp.com/send?phone=+919266391960&text=Hi, I need help." target="_blank" rel="noreferrer" className="skip-and-verify d-flex align-items-center">
                            <span className='me-1'>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.33398 8.58298C1.33398 4.85541 4.31874 1.83362 8.00062 1.83362C11.6825 1.83362 14.6672 4.85541 14.6672 8.58298L14.6673 12.0786C14.6675 12.6232 14.6676 12.9967 14.5719 13.3246C14.3847 13.9657 13.937 14.4961 13.3406 14.7833C13.0357 14.9302 12.6713 14.9883 12.1399 15.073L12.0532 15.0869C11.8643 15.1171 11.7028 15.1429 11.5688 15.1562C11.4294 15.1701 11.2872 15.1743 11.1418 15.1453C10.6634 15.05 10.2689 14.7087 10.1012 14.2451C10.0502 14.1042 10.0322 13.9614 10.024 13.8198C10.0161 13.6838 10.0161 13.5183 10.0161 13.3246L10.0161 10.543C10.0157 10.2594 10.0154 10.0153 10.0803 9.80626C10.2288 9.32803 10.6165 8.96529 11.0991 8.85307C11.31 8.80402 11.5504 8.82353 11.8296 8.8462L11.8918 8.85122L11.965 8.85705C12.4875 8.89863 12.8449 8.92707 13.1484 9.04069C13.3616 9.12054 13.5594 9.23048 13.737 9.36536V8.58298C13.737 5.37554 11.1687 2.77539 8.00062 2.77539C4.83249 2.77539 2.26421 5.37554 2.26421 8.58298V9.36536C2.44182 9.23048 2.6396 9.12054 2.85284 9.04069C3.15629 8.92707 3.51375 8.89863 4.03622 8.85705L4.10944 8.85122L4.17159 8.8462C4.45088 8.82353 4.69119 8.80402 4.90214 8.85307C5.38473 8.96529 5.77243 9.32803 5.92091 9.80626C5.98581 10.0153 5.98552 10.2594 5.98517 10.543L5.98512 13.3246C5.98513 13.5183 5.98513 13.6838 5.97723 13.8198C5.96901 13.9614 5.95099 14.1042 5.90002 14.2451C5.73234 14.7087 5.33781 15.05 4.8594 15.1453C4.71399 15.1743 4.57182 15.1701 4.43244 15.1562C4.29846 15.1429 4.13698 15.1171 3.948 15.0869L3.86136 15.073C3.32997 14.9883 2.96557 14.9302 2.66059 14.7833C2.06421 14.4961 1.61657 13.9657 1.42937 13.3246C1.35043 13.0542 1.33668 12.7528 1.33439 12.3501L1.33398 12.2205V8.58298Z" fill="white" />
                                </svg>
                            </span>
                            Help
                        </a>
                    ) : (
                        <Link to={getIntendedPath()} className="skip-and-verify">Close</Link>
                    )
                }
                leftAction={
                    error ? <a href="/logout" className="skip-and-verify"><i className="fa-solid fa-right-from-bracket me-1"></i>Logout</a> : null
                }
            >
                <ConnectIGComponent
                    error={error}
                    status={status}
                    connect={connect}
                />
            </AuthLayout>
        </MobileView>
    );
};

export default ifAuthenticated(ConnectIG);